import {ObjectDTO} from "./object-dto";

export class ReceptionStatutDTO extends ObjectDTO {


}
